<template>
  <nuxt-link
    :to="localePath(item.nuxt_slug)"
    class="products__item"
  >
    <h3
      class="products__title"
      v-html="item.title"
    ></h3>
    <div
      v-if="item.description"
      class="products__description"
      v-html="item.description"
    ></div>
    <template v-if="item.price">
      <div
        v-if="item.hasMicroData"
        itemscope
        itemtype="https://schema.org/AggregateOffer"
        itemprop="offers"
        class="products__price"
        v-html="item.price"
      ></div>
      <div
        v-else
        class="products__price"
        v-html="item.price"
      ></div>
    </template>
  </nuxt-link>
</template>

<script>
  export default {
    name: 'ProductsItem',
    props: {
      item: {
        type: Object,
        default: null
      }
    }
  }
</script>

<style lang="scss">
  .products__item {
    display: flex;
    flex-direction: column;
    min-height: 172px;
    padding: 24px;

    background: #FFFFFF;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08), 0 0 2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    border: 1px solid transparent;

    transition: all 0.2s;

    &:hover {
      color: $primary;
      border-color: $secondary;
    }

    @media (max-width: $breakpoint-lg) {
      padding: 16px 16px 24px;
    }

    @media (max-width: $breakpoint-sm) {
      min-height: 124px;
    }
  }

  .products__title {
    margin: 0 0 16px;
    color: $primary;
    transition: all 0.2s;

    .products__item:hover & {
      color: $secondary;
    }
  }

  .products__description {
    margin-bottom: auto;
    color: $primary;
  }

  .products__price {
    margin-top: 16px;
    font-weight: 600;
    color: $primary;
  }
</style>